"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoSizeInput = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _noop = require("../../../../constants/noop");
var _useTheme = require("../../../../theme/utils/useTheme");
var _inputFieldBaseProps = require("../../../../util/inputFieldBaseProps");
var _selectV2Theme = require("../selectV2Theme");
const sharedStyles = (0, _core.css)`
    box-sizing: border-box;
    font-size: inherit;
    font-weight: inherit;
    font-family: inherit;
    line-height: inherit;
    font-style: normal;
    color: inherit;

    // Just need a bit more space over the what the Inline already gives us.
    padding-left: 4px;
`;
const AutoSizeInputRoot = (0, _styled.default)("span")`
    ${sharedStyles}
    display: inline-block;
    width: auto;
    position: relative;
    height: ${_ref => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref;
  return _selectV2Theme.selectV2Theme.autoSizeInput.minHeight[(0, _inputFieldBaseProps.getInputFieldHeightValue)(themeMode, inputFieldHeight)](themeMode);
}};
`;
const AutoSizeInputSpacer = (0, _styled.default)("span")`
    ${sharedStyles}
    visibility:hidden;
    display: inline;
    white-space: pre;
`;
const AutoSizeInputInput = (0, _styled.default)("input")`
    ${sharedStyles}

    box-sizing:content-box;
    position: absolute;
    top: 0;
    bottom: 0;
    // Just need a bit more space over the what the Inline already gives us.
    left: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _selectV2Theme.selectV2Theme.autoSizeInput.left(themeMode);
}};
    width: 100%;

    margin: 0;
    padding: 0;

    border: none;
    outline: none;
    min-height: ${_ref3 => {
  let {
    themeMode,
    inputFieldHeight
  } = _ref3;
  return _selectV2Theme.selectV2Theme.autoSizeInput.minHeight[(0, _inputFieldBaseProps.getInputFieldHeightValue)(themeMode, inputFieldHeight)](themeMode);
}};
    min-width: 1px;
    background-color: transparent;

    cursor: ${_ref4 => {
  let {
    isReadonly
  } = _ref4;
  return isReadonly ? "default" : "text";
}};
`;
const AutoSizeInput = /*#__PURE__*/(0, _react.forwardRef)((_ref5, ref) => {
  let {
    className,
    clientId,
    isReadonly,
    onKeyDown,
    onKeyUp,
    value,
    ...rest
  } = _ref5;
  const handleKeyDown = (0, _lodestarUtils.useIsComposingHandler)(onKeyDown || _noop.noop);
  const handleKeyUp = (0, _lodestarUtils.useIsComposingHandler)(onKeyUp || _noop.noop);
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(AutoSizeInputRoot, {
    inputFieldHeight: rest.inputFieldHeight,
    className: className,
    themeMode: themeMode
  }, /*#__PURE__*/_react.default.createElement(AutoSizeInputSpacer, null, value), /*#__PURE__*/_react.default.createElement(AutoSizeInputInput, (0, _extends2.default)({
    isReadonly: isReadonly,
    value: value,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    themeMode: themeMode
  }, rest, {
    "data-client-id": (0, _lodestarUtils.getClientId)(clientId, "-input"),
    ref: ref
  })));
});
exports.AutoSizeInput = AutoSizeInput;
AutoSizeInput.displayName = "AutoSizeInput";
//# sourceMappingURL=AutoSizeInput.js.map